import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../models/restResponse.mode';
import { Sector } from '../../models/sector.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SectorService {
  private readonly baseUrl = `${environment.base_url}/sectors`;

  constructor(private http: HttpClient) {}

  getAll(description: string, paginate: boolean, page: number | null): Observable<RestResponse<Sector[]>> {
    const d = encodeURIComponent(description ?? '');
    return this.http.get<RestResponse<Sector[]>>(
      `${this.baseUrl}/list?description=${d}&paginate=${paginate}&page=${page}`
    );
  }

  getById(id: number): Observable<RestResponse<Sector>> {
    return this.http.get<RestResponse<Sector>>(`${this.baseUrl}/find/${id}`);
  }

  create(sector: Partial<Sector>): Observable<Sector> {
    return this.http.post<Sector>(`${this.baseUrl}/save`, sector);
  }

  update(id: number, sector: Partial<Sector>): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, sector);
  }
}
